import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MediaQuery from "react-responsive";
import Nav from "../components/nav";
import SideNav from "../components/side-nav";
import Footer from "../components/footer";
import NoticeBanner from "../components/notice-banner";
import { sideNavPath } from "../utils/general";
import { withTranslation } from "react-i18next";

const styles = {
  container: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    paddingBottom: '2rem',
  },
};

const WithHeaderLayout = ({
  children,
  currUser,
  isAuthenticated,
  handleLogout,
  history,
  classes,
  noticeBanner,
  bannerTopMobile = 53,
  ...props
}) => {
  const isSideNavPath = sideNavPath(history.location.pathname);
  
  // Calculate dynamic content padding based on banner position
  const getContentPadding = () => {
    const isDesktop = window.innerWidth >= 960;
    const headerHeight = isDesktop ? 0 : 100;
    
    return {
      paddingTop: headerHeight,
    };
  };
  const bannerEnabled = noticeBanner && noticeBanner.enabled;
  const contentWrapperStyles = bannerEnabled ? getContentPadding() : {};

  return (
    <React.Fragment>
      <Nav
        currUser={currUser}
        isAuthenticated={isAuthenticated}
        handleLogout={handleLogout}
        history={history}
        {...props}
      />
      <NoticeBanner
        message={noticeBanner && noticeBanner.message}
        messageFr={noticeBanner && noticeBanner.messageFr}
        visible={noticeBanner && noticeBanner.enabled}
        topMobile={bannerTopMobile}
      />
      {(isAuthenticated && isSideNavPath) ? (
        <>
          <MediaQuery minWidth={960}>
            <div className={classes.container}>
              <SideNav
                currUser={currUser}
                isAuthenticated={isAuthenticated}
                handleLogout={handleLogout}
                history={history}
                {...props}
              />
              <div className={classes.content} style={contentWrapperStyles}>
                {children}
              </div>
            </div>
          </MediaQuery>
          <MediaQuery maxWidth={959}>
            <div className={classes.content} style={contentWrapperStyles}>
              {children}
            </div>
          </MediaQuery>
        </>
      ):(
        <div className={classes.content} style={contentWrapperStyles}>
          {children}
        </div>
      )}
      <Footer isSideNavPath={isSideNavPath} />
    </React.Fragment>
  );
};

export default withStyles(styles)(withTranslation()(WithHeaderLayout));
